<template>
  <div class="asset-wrap">
    <Card-border></Card-border>
    <iframe :src="url" frameborder="0" ref="iframeRef"> </iframe>
  </div>
</template>
  
  <script>
import { ref, watch, onMounted, onBeforeUnmount } from 'vue';
import CardBorder from '@/components/common/card-border.vue';
import { useRouter } from 'vue-router';
export default {
  components: {
    CardBorder,
  },
  setup() {
    // let origin = window.location.origin !== 'https://local.wentian.360.cn' ? 'https://local.wentian.360.cn' : `${window.location.origin}/jiagu`;
    let origin = `${window.location.origin}/jiagu`;
    const url = ref();
    const router = useRouter();
    const iframeRef = ref(null);
    const onMessage = (e) => {
      // 过滤无关消息
      if (!e.data || e.data.type !== "fromIframe") return;
      // 拿到 iframe 参数
      const { payload } = e.data;
      let newUrl = `${origin}/#${payload.path}`;
      //修改地址栏内的URL，防止刷新后还在详情页
      window.history.pushState({}, "", `/#${payload.path}`);
      url.value = newUrl;
    };
    onMounted(() => {
      window.addEventListener("message", onMessage);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("message", onMessage);
    });
    // 监听路由变化
    watch(
      () => router.currentRoute.value.path,
      () => {
        url.value = `${origin}/${window.location.hash}`;
      },
      { immediate: true }
    );
    return {
      url,
      iframeRef
    };
  },

}
</script>
  
  <style lang="less">
@import url('./index.less');
</style>
  